import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MainService } from 'src/app/services/main.service';

@Component({
  selector: 'app-modal-asset-history',
  templateUrl: './modal-asset-history.component.html',
  styleUrls: []
})
export class ModalAssetHistoryComponent implements OnInit {

  history: any = [];
  loading: boolean = true;

  constructor(
    private mService: MainService,
    public dialogRef: MatDialogRef<ModalAssetHistoryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.mService.get_request(`assets/${this.data.id}/history`)
    .subscribe((resp: any)=>{
      this.loading = false;
      if(resp.status){
        this.history = resp.items || [];
      }
    });
  }

  ngOnInit(): void { }

  dismiss(){
    this.dialogRef.close(null);
  }
}
